import React from 'react';
import { Card, CardContent } from './ui/card';
import { BookOpen, FileText, PenTool } from 'lucide-react';

const WritingSection = ({ writingData }) => {
  if (!writingData || writingData.length === 0) return null;

  const getTypeIcon = (type) => {
    switch (type) {
      case 'poetry':
        return <PenTool className="w-5 h-5" />;
      case 'essay':
        return <FileText className="w-5 h-5" />;
      case 'short-story':
        return <BookOpen className="w-5 h-5" />;
      default:
        return <BookOpen className="w-5 h-5" />;
    }
  };

  return (
    <section id="writing" className="py-24 px-6 relative overflow-hidden bg-black">
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-6">
            <BookOpen className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-sm font-medium text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>Literary Works</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white" style={{ fontFamily: 'Cinzel, serif' }}>
            Written Word
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Poetry and prose exploring transformation, identity, and the human experience
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {writingData.map((work) => (
            <Card 
              key={work.id}
              className="bg-black border-2 border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-all duration-300 group cursor-pointer"
            >
              <CardContent className="p-6 space-y-4">
                <div className="flex items-start justify-between">
                  <div className="p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37] group-hover:bg-[#D4AF37]/20 transition-colors">
                    {getTypeIcon(work.type)}
                  </div>
                  <span className="text-xs px-3 py-1 bg-[#D4AF37]/20 text-[#D4AF37] font-semibold">
                    {work.year}
                  </span>
                </div>
                
                <div>
                  <div className="text-xs uppercase tracking-wider text-gray-500 mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {work.type.replace('-', ' ')}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: 'Cinzel, serif' }}>
                    {work.title}
                  </h3>
                  <p className="text-sm text-gray-400 leading-relaxed mb-4">
                    {work.description}
                  </p>
                </div>
                
                {work.excerpt && (
                  <div className="pt-4 border-t border-[#D4AF37]/20">
                    <p className="text-xs italic text-gray-500 leading-relaxed">
                      {work.excerpt}
                    </p>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">
            Forthcoming debut two-part album accompanied by poetry and future literary works
          </p>
          <div className="inline-block px-6 py-3 bg-[#D4AF37]/5 border border-[#D4AF37]/30">
            <span className="text-[#D4AF37] font-semibold">Stay tuned for more literary releases</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WritingSection;